export const getNextDuplicateFileName = (fileName, usedNames) => {
	const extensionIndex = fileName.lastIndexOf('.');
	const hasExtension = extensionIndex > 0;
	const baseName = hasExtension ? fileName.substring(0, extensionIndex) : fileName;
	const extension = hasExtension ? fileName.substring(extensionIndex) : '';

	let suffix = 1;
	let candidate = `${baseName} (${suffix})${extension}`;

	while (usedNames.has(candidate.toLowerCase())) {
		suffix += 1;
		candidate = `${baseName} (${suffix})${extension}`;
	}

	return candidate;
};

export const prepareFilesWithUniqueNames = async (files, existingNames, promptForDuplicateName) => {
	const prepared = [];
	const usedNames = new Set((existingNames || []).filter(n => !!n).map(n => n.toLowerCase()));

	for (let i = 0; i < files.length; i += 1) {
		const file = files[i];
		let selectedName = file.name;

		while (usedNames.has(selectedName.toLowerCase())) {
			const suggestedName = getNextDuplicateFileName(selectedName, usedNames);
			const newName = await promptForDuplicateName(file.name, suggestedName);
			if (!newName) {
				selectedName = null;
				break;
			}
			selectedName = newName.trim() || suggestedName;
		}

		if (!selectedName) {
			continue;
		}

		usedNames.add(selectedName.toLowerCase());
		prepared.push({
			file,
			fileName: selectedName,
			sizeBytes: file.size
		});
	}

	return prepared;
};
